import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Check } from "lucide-react";

export default function NotificationBell({ dark }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [items, setItems] = useState([]);
  const ref = useRef(null);

  const loadCount = () => api.get("/notifications/count").then((r) => setCount(r.data.unread || 0)).catch(() => {});
  const loadList = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 20000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = () => { const n = !open; setOpen(n); if (n) loadList(); };
  const openItem = async (it) => {
    try { await api.post(`/notifications/${it.id}/read`); } catch (e) {}
    setOpen(false); loadCount();
    if (it.link) nav(it.link);
  };
  const markAll = async () => { try { await api.post("/notifications/read-all"); } catch (e) {} loadCount(); loadList(); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={toggle} className={`relative rounded-md p-2 ${dark ? "text-white/70 hover:bg-white/10 hover:text-white" : "hover:bg-slate-100"}`}>
        <Bell className={`h-5 w-5 ${dark ? "" : "text-slate-600"}`} />
        {count > 0 && <span data-testid="notif-badge" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-brand-orange px-1 text-[10px] font-bold text-white">{count > 9 ? "9+" : count}</span>}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute right-0 lg:left-0 lg:right-auto z-50 mt-2 w-80 max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-slate-200">
          <div className="flex items-center justify-between border-b px-3 py-2">
            <span className="text-sm font-semibold text-slate-700">Bildirimler</span>
            <button data-testid="notif-readall" onClick={markAll} className="flex items-center gap-1 text-[11px] text-brand-green hover:underline"><Check className="h-3 w-3" /> Tümünü okundu</button>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 ? (
              <p className="px-3 py-8 text-center text-sm text-slate-400">Bildirim yok.</p>
            ) : items.map((it) => (
              <button key={it.id} data-testid={`notif-item-${it.id}`} onClick={() => openItem(it)} className={`block w-full border-b px-3 py-2.5 text-left hover:bg-slate-50 ${!it.read ? "bg-emerald-50/60" : ""}`}>
                <p className="text-[13px] font-medium text-slate-800">{it.title}</p>
                <p className="text-[11px] text-slate-500">{it.body}</p>
                <p className="mt-0.5 text-[10px] text-slate-400">{String(it.created_at).slice(0, 16).replace("T", " ")}</p>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
